import createReducer from 'utils/createReducer';

// Initial State
const INITIAL_STATE = {
  count: 0,
  pageSize: 30,
  data: [],
  single: {
    fetching: false,
    data: null,
  },
  fetching: false,
  fetchingMore: false,
  pushing: false,
  error: null,
  next: null,
  searching: false,
};

// Actions
const SET_STAFF = 'staff/SET_STAFF';
const ADD_STAFF = 'staff/ADD_STAFF';
const UPDATE_STAFF = 'staff/UPDATE_STAFF';
const SET_SEARCHING = 'staff/SET_SEARCHING';
const SET_FETCHING = 'staff/SET_FETCHING';
const SET_FETCHING_MORE = 'staff/SET_FETCHING_MORE';
const SET_SINGLE_STAFF = 'staff/SET_SINGLE_STAFF';
const SET_FETCHING_SINGLE = 'staff/SET_FETCHING_SINGLE';
const SET_PUSHING = 'staff/SET_PUSHING';
const SET_ERROR = 'staff/SET_ERROR';
const RESET_ERROR = 'staff/RESET_ERROR';

// Reducers
export default createReducer(INITIAL_STATE, {
  [SET_STAFF](state, { results: data, ...props }) {
    return {
      ...state,
      ...props,
      data,
    };
  },
  [ADD_STAFF](state, { results: data, ...props }) {
    return {
      ...state,
      ...props,
      data: [...state.data, ...data],
    };
  },
  // TODO
  [UPDATE_STAFF](state, payload) {
    return {
      ...state,
      data: state.data.map((s) => (s.id === payload.id ? { ...s, ...payload } : s)),
    };
  },
  [SET_SINGLE_STAFF](state, payload) {
    return {
      ...state,
      single: {
        ...state.single,
        data: payload,
      },
    };
  },
  [SET_SEARCHING](state, payload) {
    return {
      ...state,
      searching: payload,
    };
  },
  [SET_FETCHING](state, payload) {
    return {
      ...state,
      fetching: payload,
    };
  },
  [SET_FETCHING_MORE](state, payload) {
    return {
      ...state,
      fetchingMore: payload,
    };
  },
  [SET_FETCHING_SINGLE](state, payload) {
    return {
      ...state,
      single: {
        ...state.single,
        fetching: payload,
      },
    };
  },
  [SET_PUSHING](state, payload) {
    return {
      ...state,
      pushing: payload,
    };
  },
  [SET_ERROR](state, payload) {
    return {
      ...state,
      error: payload,
    };
  },
  [RESET_ERROR](state, payload) {
    return {
      ...state,
      error: payload,
    };
  },
});

// Action creators
export const setStaff = (staff) => ({
  type: SET_STAFF,
  payload: staff,
});

export const addStaff = (staff) => ({
  type: ADD_STAFF,
  payload: staff,
});

export const setSearching = (searching) => ({
  type: SET_SEARCHING,
  payload: searching,
});

export const setFetching = (fetching) => ({
  type: SET_FETCHING,
  payload: fetching,
});

export const setFetchingMore = (fetchingMore) => ({
  type: SET_FETCHING_MORE,
  payload: fetchingMore,
});

export const setPushing = (pushing) => ({
  type: SET_PUSHING,
  payload: pushing,
});

export const setSingleStaff = (staff) => ({
  type: SET_SINGLE_STAFF,
  payload: staff,
});

export const setFetchingSingle = (fetchingSingle) => ({
  type: SET_FETCHING_SINGLE,
  payload: fetchingSingle,
});

export const throwError = (code = '', body = []) => ({
  type: SET_ERROR,
  payload: {
    code: code,
    errors: body,
  },
});

export const resetError = () => ({
  type: RESET_ERROR,
  payload: null,
});

export const updateStaff = (staff) => ({
  type: UPDATE_STAFF,
  payload: staff,
});
